module.exports = __WEBPACK_EXTERNAL_MODULE_mobx_react__;